import { Partner } from '~/data/common'
import SUPERSIM from '@/data/faqs/supersim/aboutSupersim'
import NOVERDE from '@/data/faqs/noverde/aboutNoverde'
import REBEL from '@/data/faqs/geru/aboutGeru'
import SIMPLIC from '@/data/faqs/simplic/aboutSimplic'
import PROVU from '@/data/faqs/provu/aboutProvu'
import CREFAZ from '@/data/faqs/crefaz/aboutCrefaz'
import AGIL from '@/data/faqs/agil/aboutAgil'
import JBCRED from '@/data/faqs/jbcred/aboutJbcred'
import BV_FGTS from '@/data/faqs/fgts/aboutFgts'
import JUVO from '@/data/faqs/juvo/aboutJuvo'
import PICPAY from '~/data/faqs/picpay/aboutPicPay'
import HCRED from '@/data/faqs/hcred/aboutHCred'
import UPP from '@/data/faqs/upp/aboutUpp'
import BLIPAY from '@/data/faqs/blipay/aboutBlipay'
import ZIPPI from '@/data/faqs/zippi/aboutZippi'
import ZILICRED from '@/data/faqs/zilicred/aboutZilicred'
import KOIN from '@/data/faqs/koin/aboutKoin'

export const PartnersFaq: Record<Partner | string, string | any> = {
  SUPERSIM,
  NOVERDE,
  REBEL,
  SIMPLIC,
  PROVU,
  CREFAZ,
  AGIL,
  JBCRED,
  BV_FGTS,
  JUVO,
  PICPAY,
  HCRED,
  UPP,
  BLIPAY,
  ZIPPI,
  ZILICRED,
  KOIN,
}
